<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <div class="modal-card-title">
                <p>
                    <b-icon icon="tools" class="m-2"></b-icon>
                    {{ mat }}
                </p>
                <div class="field has-text-right">
                    <b-tag type="is-info">{{ uuid }}</b-tag>
                </div>
            </div>
        </header>
        <section class="modal-card-body">

            <b-field label="Coût">
                <b-input type="number" min="0" step="0.01" v-model="costSaisie">
                </b-input>
            </b-field>

            <b-field label="N° devis">
                <b-input type="text" v-model="devisSaisie" placeholder="N° de devis">
                </b-input>
            </b-field>

          <b-field label="Commentaire">
            <b-input type="text" v-model="commentSaisie" placeholder="Commentaire">
            </b-input>
          </b-field>


        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">
                Annuler
            </button>
            <button class="button is-primary" @click="editMAT">Enregistrer</button>
        </footer>
    </div>
</template>

<script>
    export default {
        name: "MATEditModal",
        props: {
            cost: {
                required: true
            },
          comment: {
            required: true
          },
          devis: {
            required: true
          },
            mat: {
                required: true
            },
            uuid: {
                required: true
            },
        },
        data() {
          return {
            costSaisie: 0,
            commentSaisie: '',
            devisSaisie: '',
          }
        },
        mounted() {
          this.costSaisie = this.cost;
          this.devisSaisie = this.devis;
          this.commentSaisie = this.comment;
        },
        methods: {
            editMAT() {
                if (parseFloat(this.costSaisie) >= 0) {
                    const payload = {
                        uuid: this.uuid,
                        mat: this.mat,
                        cost: this.costSaisie,
                        devis: this.devisSaisie,
                        comment: this.commentSaisie
                    };
                    this.$emit("edit-mat", payload);
                } else {
                    this.$buefy.snackbar.open(
                        {
                            message: `Mauvaise saisie, merci de vérifier`,
                            type: 'is-danger',
                            position: 'is-bottom-left'
                        });
                }
            }
        }
    };
</script>

<style scoped></style>
